import React, {Component} from 'react';
import Moment from 'react-moment';
import EuroFormat from '../../../components/EuroFormat/EuroFormat';
import Loading from '../../../components/Loading';
import WHTable from '../../../components/WHTable';
import ApiConfig from '../../../constants/ApiConfig';

import {
    Card,
    CardHeader,
    CardBody,
    Table,
    Badge,
    DropdownItem,
    Button
} from 'reactstrap';

import {connect} from 'react-redux';

import * as pageService from '../../../services/page';

class Pages extends Component {

    constructor(props) {

        super(props);

        this.state = {
            data : [],
            col : [],
            pages: null,
            loaded : true
        }
        this.load = this.load.bind(this);
        this.columns = this.columns.bind(this);
        this.showdetails = this.showdetails.bind(this);

    }


    columns() {

        return [

            {
                Header: '',
                accessor: 'id',
                filterable: false,
                Cell: row => (<Button color={'success'} onClick={() => this.showdetails(row.value)}>Details</Button>),
                maxWidth: 80
            },
            {
                Header: 'titre',
                accessor: 'title'

            },
            {
                Header: 'Resumé',
                accessor: 'summary'
            },
            {
                Header: 'date de publication',
                accessor: 'publication_date',
                Cell: row => (<Moment format="DD/MM/YYYY">{row.value}</Moment>),
                maxWidth:150,
                filterable: false
            },
        ];

    }

    showdetails(id) {

        this.props.history.push(`/pages/edit/${id}`);

    }

    load(state, instance) {

        this.setState({loaded : false});

        return pageService.search(state).then((data) => {

            this.setState({data : []}, () => {
                this.setState({
                    data : data['hydra:member'],
                    pages : Math.ceil(data['hydra:totalItems'] / state.pageSize),
                    loaded : true
                })});


        });

    }

    render() {


        const {history, match} = this.props;
        const { data, pages, loading } = this.state;

        return (
            <div className="animated fadeIn">



                <Card>
                    <CardHeader>
                        <i className="fa fa-align-justify"></i> Gestion des pages

                        <div className="card-actions">
                            <a href={`#/pages/edit`}><i className={'fa fa-plus'}></i> Créer</a>
                          {/*   <a href={`${ApiConfig.helpAdmin}/cms/pages.html`} target={'_blank'}><i className={'fa fa-question'}></i></a> */}
                        </div>

                    </CardHeader>

                    <WHTable
                        data={data}
                        pages={pages}
                        columns={this.columns()}
                        filterable={true}
                        onFetchData={this.load}
                        loading={!this.state.loaded}
                    />

                </Card>


            </div>
        )
    }
}

export default Pages





// WEBPACK FOOTER //
// ./src/views/Cms/Pages/Pages.js